const getIsTouchDevice = (): boolean => 'ontouchstart' in window || window.matchMedia('(pointer: coarse)').matches

export default getIsTouchDevice
